
import React from "react";
const ContractsIcon = (props) => {
  return (
    <div></div>
  );
}
export default ContractsIcon;
